// @ts-nocheck
import React from 'react'
import cx from 'classnames'

export const Card = ({
  title = '',
  actions,
  children,
  className,
  ...props
}) => (
  <article className={cx('Card', className)} {...props}>
    {children}
  </article>
)

export default Card
